(function (root, factory) {
  var engine = factory();
  if (typeof module === 'object' && module.exports) {
    module.exports = engine;
  }
  root.RetirementGoalEngine = engine;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  function calculateRequiredMonthly(retirementGoal, currentSavings, yearsToRetirement, rate) {
    var n = yearsToRetirement * 12;
    var r = rate / 100 / 12;
    var fvCurrentSavings = currentSavings * Math.pow(1 + r, n);
    var amountNeeded = retirementGoal - fvCurrentSavings;

    if (amountNeeded <= 0) {
      return 0;
    }

    if (r === 0) {
      return amountNeeded / n;
    }

    var compoundFactor = Math.pow(1 + r, n);
    var pmt = (amountNeeded * r) / (compoundFactor - 1);
    return Math.max(0, pmt);
  }

  function calculate(input) {
    var yearsToRetirement = Math.max(1, input.retirementAge - input.currentAge);
    var monthlyRate = input.expectedReturn / 100 / 12;
    var months = yearsToRetirement * 12;

    var requiredMonthlySavings = calculateRequiredMonthly(
      input.retirementGoal,
      input.currentSavings,
      yearsToRetirement,
      input.expectedReturn
    );

    var projectedFromCurrent = input.currentSavings * Math.pow(1 + monthlyRate, months);
    var alreadyOnTrack = projectedFromCurrent >= input.retirementGoal;

    var totalContributions = input.currentSavings + (requiredMonthlySavings * months);

    var scenarios = [];
    [5, 6, 7, 8, 9, 10].forEach(function (rate) {
      scenarios.push({
        rate: rate,
        monthly: calculateRequiredMonthly(input.retirementGoal, input.currentSavings, yearsToRetirement, rate)
      });
    });

    // Monthly compounding with end-of-month contributions, matching the annuity
    // formula in calculateRequiredMonthly, so contributing the required amount
    // lands the projection exactly on the target.
    var yearlyData = [];
    var balance = input.currentSavings;
    var yearlyContribution = requiredMonthlySavings * 12;

    for (var year = 1; year <= yearsToRetirement; year++) {
      var startBalance = balance;
      var contributions = yearlyContribution;

      for (var month = 0; month < 12; month++) {
        balance = balance * (1 + monthlyRate) + requiredMonthlySavings;
      }

      var endBalance = balance;
      var growth = endBalance - startBalance - contributions;

      yearlyData.push({
        year: year,
        age: input.currentAge + year,
        startBalance: startBalance,
        contributions: contributions,
        growth: growth,
        endBalance: endBalance
      });
    }

    var finalBalance = yearlyData.length > 0 ? yearlyData[yearlyData.length - 1].endBalance : input.currentSavings;
    var shortfall = finalBalance - input.retirementGoal;
    var totalGrowth = finalBalance - totalContributions;

    var milestones = [25, 50, 75, 100].map(function (pct) {
      var targetAmount = input.retirementGoal * (pct / 100);
      var milestoneYear = 0;

      for (var i = 0; i < yearlyData.length; i++) {
        if (yearlyData[i].endBalance >= targetAmount) {
          milestoneYear = yearlyData[i].year;
          break;
        }
      }

      return {
        percent: pct,
        amount: targetAmount,
        year: milestoneYear || yearsToRetirement
      };
    });

    var labels = [input.currentAge].concat(yearlyData.map(function (d) { return d.age; }));
    var balances = [input.currentSavings].concat(yearlyData.map(function (d) { return d.endBalance; }));
    var contributionsSeries = [input.currentSavings];
    var totalContrib = input.currentSavings;

    yearlyData.forEach(function (row) {
      totalContrib += row.contributions;
      contributionsSeries.push(totalContrib);
    });

    return {
      yearsToRetirement: yearsToRetirement,
      requiredMonthlySavings: requiredMonthlySavings,
      projectedFromCurrent: projectedFromCurrent,
      alreadyOnTrack: alreadyOnTrack,
      totalContributions: totalContributions,
      totalGrowth: totalGrowth,
      shortfall: shortfall,
      scenarios: scenarios,
      yearlyData: yearlyData,
      milestones: milestones,
      chart: {
        labels: labels,
        balances: balances,
        contributions: contributionsSeries,
        goalLine: labels.map(function () { return input.retirementGoal; })
      }
    };
  }

  return {
    calculate: calculate,
    calculateRequiredMonthly: calculateRequiredMonthly
  };
});
